<template>
  <div id="app">

    <el-container >

      <el-header style="height:auto;padding:0px;border:1px solid #000;margin-bottom: 4px;">
        <el-image style="width: 100%; height: auto;margin-bottom: 0px;" :src="require('@/assets/top.jpg')" fit="fill"></el-image>


        <el-image style="width: 100%; height: 30px;" class="nomargin" :src="require('@/assets/top1.jpg')" fit="fill"></el-image>

        <div class="funlink">
          <!-- <el-link  @click="fun(1)" style="color:white;font-weight:bold;margin-right: 30px;font-size:16px;" >&lt;Games</el-link>
          <el-link  @click="fun(2)" style="color:white;font-weight:bold;margin-right: 30px;font-size:16px;">&lt;Term of Use</el-link>
          <el-link  @click="fun(3)" style="color:white;font-weight:bold;margin-right: 30px;font-size:16px;">&lt;Private Policy</el-link>
          <el-link  @click="fun(4)" style="color:white;font-weight:bold;margin-right: 30px;font-size:16px;">&lt;Contact Us</el-link> -->

          <el-row :gutter="20">
            <el-col :span="8" style="padding-left: 0px;padding-right: 0px;"><el-link  @click="fun(1)" style="color:white;font-weight:bold;font-size:0.8em;" >&lt;Games</el-link></el-col>
            <!-- <el-col :span="6" style="padding-left: 0px;padding-right: 0px;"><el-link  @click="fun(2)" style="color:white;font-weight:bold;font-size:0.8em;">&lt;Term of Use</el-link></el-col> -->
            <el-col :span="8" style="padding-left: 0px;padding-right: 0px;"><el-link  @click="fun(3)" style="color:white;font-weight:bold;font-size:0.8em;">&lt;Private Policy</el-link></el-col>
            <el-col :span="8" style="padding-left: 0px;padding-right: 0px;"><el-link  @click="fun(4)" style="color:white;font-weight:bold;font-size:0.8em;">&lt;Contact Us</el-link></el-col>
          </el-row>

        </div>

      </el-header>

      <el-main style="padding-top: 0px;padding-left: 0px;padding-right: 0px;padding-bottom: 0px;margin-bottom: 3px;border:1px solid #000;">
        <!-- <el-button>默认按钮</el-button>
        <el-button type="primary">主要按钮</el-button> -->
        <div v-if="actfun==1">
          <!-- <el-image style="width: 100%; height: auto;margin-bottom: 2px;border:1px solid #000;" :src="require('@/assets/main_up.jpg')" fit="fill"></el-image> -->

          <a href="https://play.google.com/store/apps/details?id=com.blockssmasher.gp" target="_blank" >
            <el-image style="width: 100%; height: auto;"  :src="require('@/assets/main_down.jpg')" fit="fill"></el-image>
          </a>
        </div>

        <div v-if="actfun==2" v-html="htmlstr" style="text-align: left;padding-left: 10px;padding-right: 10px;overflow:hidden;">
        </div>

        <div v-if="actfun==3" v-html="htmlstr"  style="text-align: left;padding-left: 10px;padding-right: 10px;overflow:hidden;">
        </div>

        <div v-if="actfun==4" v-html="htmlstr"  style="text-align: left;padding-left: 10px;padding-right: 10px;overflow:hidden;">
        </div>

      </el-main>

      <el-footer>©2020 ThirtyNine Interactive Limited</el-footer>
    </el-container>

  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import pdf from 'vue-pdf'


export default {
  data() {
    return {
      actfun: 1,
      htmlstr:'',
      pdfsrc:''
    }
  },
  methods:{
    load (url) {
      if (url && url.length > 0) {
        let self = this
        let param = {
          accept: 'text/html, text/plain'
        }
        self.$http.get(url, param).then((response) => {
          self.htmlstr = response.data
        }).catch(() => {
          self.htmlstr = 'Failed to load, please refresh it'
        })
      }
    },
    fun(atype){
      // alert(atype+'haha')
      this.actfun = atype
      if(atype=='2'){
        this.load('./static/tou.html?v=1')
      }
      if(atype=='3'){
        this.load('./static/pp.html?v=1')
      }
      if(atype=='4'){
        this.load('./static/contactus.html?v=1')
      }
    }
  }
}
</script>

<style>

html,body {
  height: 100%;
  width: 100%;
  max-width: 1190px;
  text-align: center;
  margin:0 auto;

  padding-left: 0px;
  padding-right: 0px;

  /* margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  margin-right: 0px; */

  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  width: 100%;
  background-color: #ffffff;
}


.funlink {
  /* display: block; */
  color: white;
  margin-top: -33px;
  height: 28px;
  padding-top: 5px;
}
.nomargin {
  margin-top: -5px;
  margin-left: 0px;
  margin-bottom: 0px;
  margin-right: 0px;

}
.el-image{
  overflow:visible;
}

  .el-header{
    background-color: #ffffff;
    color: #333;
    text-align: center;
    height: auto;
    line-height: auto;
  }

  .el-footer {
    background-color: black;
    color: #c0c0c0;
    text-align: center;
    line-height: 60px;
    /* align-self:flex-end; */
  }
  
  .el-aside {
    background-color: #ffffff;
    color: #333;
    text-align: center;
    line-height: 200px;
    
  }
  
  .el-main {
    background-color: #ffffff;
    color: #333;
    text-align: center;
    /* line-height: 160px; */
    
  }
  
  .el-container {
    height: 100%;
  }
  

</style>
